import { render, staticRenderFns } from "./fix.vue?vue&type=template&id=53e9d30b&scoped=true&"
import script from "./fix.vue?vue&type=script&lang=js&"
export * from "./fix.vue?vue&type=script&lang=js&"
import style0 from "./fix.vue?vue&type=style&index=0&id=53e9d30b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9d30b",
  null
  
)

export default component.exports